import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDarkModeCopyIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.03125 0.875C3.66882 0.875 3.375 1.16882 3.375 1.53125V4.15625C3.375 4.51868 3.66882 4.8125 4.03125 4.8125H7.96875C8.33117 4.8125 8.625 4.51868 8.625 4.15625V1.53125C8.625 1.16882 8.33117 0.875 7.96875 0.875H4.03125ZM4.6875 3.5V2.1875H7.3125V3.5H4.6875ZM2.17235 3.09137C2.48608 2.90989 2.59328 2.50844 2.4118 2.19472C2.23032 1.88099 1.82887 1.77378 1.51515 1.95527C1.05917 2.21904 0.75 2.71365 0.75 3.28126V11.5938C0.75 12.4394 1.43556 13.125 2.28125 13.125H9.7188C10.5644 13.125 11.25 12.4394 11.25 11.5938V3.28126C11.25 2.71365 10.9409 2.21904 10.4848 1.95527C10.1711 1.77378 9.7697 1.88099 9.5882 2.19472C9.4067 2.50844 9.5139 2.90989 9.8277 3.09137C9.8947 3.13018 9.9375 3.20112 9.9375 3.28126V11.5938C9.9375 11.7146 9.8396 11.8125 9.7188 11.8125H2.28125C2.16044 11.8125 2.0625 11.7146 2.0625 11.5938V3.28126C2.0625 3.20112 2.10525 3.13018 2.17235 3.09137Z",
		fill: "#94a3b8"
	})
});
export default SvgDarkModeCopyIcon;
